import { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaTruck, FaRoute, FaChevronDown, FaChevronUp, FaStar, FaTrash } from 'react-icons/fa';
import { Badge, Card, Button, Form, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import decryptData from '../../helpers/Decryption';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { errorMessageString } from '../../helpers/utils';

export default function TransitCard() {
    const [expanded, setExpanded] = useState({});
    const [locations, setLocations] = useState([]);
    const { getToken } = useAuth();
    const navigate = useNavigate();
    const [selectedItem, setSelectedItem] = useState();
    const [loading, setLoading] = useState(false);
    const [showDelDemo, setShowDelDemo] = useState(false);

    useEffect(() => {
        getCommuterLocations();
    }, []);

    const getCommuterLocations = async () => {
        const authToken = getToken();
        if (authToken) {
            try {
                const res = await new WebApiCalls().getCommuterLocations(authToken);
                if (res?.code === 200) {
                    const decryptedData = await decryptData(res.data);

                    // Populate transit_types dynamically
                    const updatedLocations = decryptedData.map((location) => {
                        const transitTypes = [...new Set(location.transit_agencies.flatMap((agency) => agency.transit_mediums || []))];
                        return { ...location, transit_types: transitTypes };
                    });

                    setLocations(updatedLocations || []);
                }
            } catch (err) {
                console.error('Error fetching locations:', err);
            }
        }
    };

    const updateDefaultLocation = async (locationId) => {
        const authToken = getToken();
        if (!authToken) return;

        try {
            const res = await new WebApiCalls().setDefaultLocation(authToken, locationId);
            if (res?.code === 200) {
                toast.success('Default location updated successfully');

                setLocations((prevLocations) =>
                    prevLocations.map((loc) => ({
                        ...loc,
                        is_default: loc._id === locationId
                    }))
                );
            }
        } catch (error) {
            console.error('Error updating default location:', error);
        }
    };

    const handleDeleteLocation = async () => {
        const authToken = getToken();
        if (!authToken) return;

        if (selectedItem) {
            setLoading(true);

            try {
                const res = await new WebApiCalls().deleteLocation(authToken, selectedItem);
                if (res?.code === 200) {
                    toast.success('Location deleted successfully');
                    setLoading(false);
                    getCommuterLocations();
                    setLocations((prevLocations) => prevLocations.filter((loc) => loc._id !== selectedItem));
                }
            } catch (error) {
                setLoading(false);
                let errorMessage = errorMessageString(error);
                setLoading(false);

                toast.error(errorMessage);
            }
        }
    };

    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const handleClose = () => {
        setShowDelDemo(false);
    };

    return (
        <div className="p-4 mx-auto bg-light d-flex flex-column align-items-center py-5">
            <CommonModal handleClose={handleClose} show={showDelDemo} handleDelete={handleDeleteLocation} text={'Are you sure, you want to delete location?'} />

            {/* Header Row */}
            <Row style={{ position: 'relative', top: -94 }} className="mb-3 w-100 d-flex justify-content-end">
                <Col xs="auto">
                    <Button className="add-record-btn justify-content-center w-140" style={{ background: '#13aa61' }} onClick={() => navigate('add-location')}>
                        Add Location
                    </Button>
                </Col>
            </Row>

            <Row className="w-100">
                {locations.length === 0 && (
                    <div className="text-center">
                        <p>There are no records to display</p>
                    </div>
                )}
                {locations.map((location) => (
                    <Col sm={12} md={6} lg={6} xl={6} xxl={3} key={location._id} className="mb-4">
                        <Card className={`card w-100 shadow-lg ${location.is_default ? 'card-primary' : ''}`}>
                            <Card.Header className="bg-success-color text-white  card-header">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <h5 className="mb-0">{location.title}</h5>
                                        {/* {location.is_default && (
                                            <Badge bg="warning" text="dark" className="ms-2">
                                                <FaStar className="me-1" /> Default
                                            </Badge>
                                        )} */}
                                    </div>
                                    <Badge bg="bg-success-color header-badge" text="light">
                                        {Array.isArray(location.transit_agencies)
                                            ? // ? location.transit_agencies.map((agency) => agency.name).join(', ')
                                              location.transit_agencies[0]?.name
                                            : 'No Transit Agency'}
                                    </Badge>
                                </div>
                                <div className="d-flex align-items-center route-first">
                                    <div className="text-white p-2">
                                        <FaTruck />
                                    </div>
                                    <div className="p-2 rounded mb-2">
                                        <div className="route-name">
                                            <strong className="text-white">Route 1:</strong>{' '}
                                        </div>
                                        <div className=" route-name">
                                            <strong className="text-white">
                                                {`${location.start_station?.stop_name} - ${location.start_station?.stop_code}` || 'N/A'}
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                            </Card.Header>

                            <Card.Body>
                                <div className="d-flex">
                                    <div className="stations-icons d-flex flex-column me-3">
                                        <div className="text-white p-2 rounded-circle rounded-circle-success-icon">
                                            <FaMapMarkerAlt />
                                        </div>
                                        <div className="stations-icons-mid border-start border-2 border-success my-2" style={{ height: '40px' }}></div>
                                        <div className="bg-danger text-white p-2 rounded-circle rounded-circle-danger-icon">
                                            <FaRoute />
                                        </div>
                                    </div>

                                    <div className="flex-grow-1">
                                        <div className="station-wrp bg-light p-2 rounded mb-2">
                                            <strong className="text-success">Start Station:</strong>
                                            <span className="text-black">{`${location.start_station?.stop_name} - ${location.start_station?.stop_code}` || 'N/A'}</span>
                                        </div>

                                        <div className="station-wrp bg-light p-2 rounded mb-2">
                                            <strong className="text-danger">End Station:</strong>
                                            <span className="text-black">{`${location.end_station?.stop_name} - #${location.end_station?.stop_code}` || 'N/A'}</span>
                                        </div>
                                        <div className="transit-type bg-light p-2 rounded  mb-2">
                                            <strong className="text-black">Transit Types: </strong>
                                            <span className="text-black">{location.transit_types?.join(', ') || ' N/A'}</span>
                                        </div>
                                    </div>
                                </div>

                                {location.additional_stations.length > 0 && (
                                    <>
                                        {/* Additional stations toggle */}
                                        <Button
                                            variant="outline-success"
                                            className="w-100 mt-3 d-flex justify-content-between align-items-center"
                                            onClick={() => toggleExpand(location._id)}
                                        >
                                            <span>Additional Stations</span>
                                            <span className="ms-auto">{expanded[location._id] ? <FaChevronUp /> : <FaChevronDown />}</span>
                                        </Button>

                                        {expanded[location._id] && (
                                            <div className="space-y-3 pl-8 pt-1 pb-2">
                                                {location.additional_stations.map((station, index) => (
                                                    <div key={index} className="flex items-center gap-3 bg-gray-50/50 p-3 rounded-lg shadow-sm">
                                                        <div className="ms-4">
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {station.stop_agency_id?.name ? `Agency: ${station.stop_agency_id.name}` : ''}
                                                            </p>
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {location.transit_types?.join(', ')
                                                                    ? `Transit Types: ${location.transit_types?.join(', ') || ' N/A'}`
                                                                    : ''}
                                                            </p>
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {station.route_id?.name ? `Route: ${station.route_id.name}` : ''}
                                                            </p>
                                                            <p className="text-sm addtional-stations-text font-medium text-gray-900">
                                                                {`${station.start_station_id?.stop_name} - #${station.start_station_id?.stop_code}` || 'N/A'}
                                                            </p>
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {station.trip_id?.name ? `Trip: ${station.trip_id.name}` : ''}
                                                            </p>
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {station.start_station_id?.name
                                                                    ? `Start Station: ${station.start_station_id?.stop_name} - #${station.start_station_id?.stop_code}`
                                                                    : ''}
                                                            </p>
                                                            <p className="text-xs addtional-stations-text text-gray-600">
                                                                {station.end_station_id?.name
                                                                    ? `End Station: ${station.end_station_id?.stop_name} - #${station.end_station_id?.stop_code}`
                                                                    : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}

                                <div className="d-flex justify-content-between mt-2">
                                    {/* Set Default Checkbox */}
                                    <Form.Check
                                        type="checkbox"
                                        label="Set as Default"
                                        checked={location.is_default}
                                        onChange={() => updateDefaultLocation(location._id)}
                                        className="mt-2"
                                        disabled={location.is_default}
                                    />
                                    <div className="station-del d-flex text-end">
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            className="ms-2 d-flex justify-content-between align-items-center"
                                            onClick={() => {
                                                setSelectedItem(location._id);
                                                setShowDelDemo(true);
                                            }}
                                        >
                                            <span className="ms-auto">
                                                <FaTrash />
                                            </span>
                                        </Button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
}
